import * as React from "react";
import { useSelector } from "react-redux";
import "./Navbar.css";
import { Badge, Typography, AppBar, Box, Toolbar, Menu, Link, Tooltip, MenuItem, Container, Button } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import LocalDiningIcon from '@mui/icons-material/LocalDining';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { toast } from "react-toastify";
import { getToken } from "app/services/UtilServices";
import TranslateComponent from "components/Miscellaneous/TranslateComponent";


const Navbar = () => {

  //@ts-ignore
  const cartItems = useSelector((state) => state.cart.items);
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const isLoggedIn = !!getToken(); // Check login status once

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleLogout = () => {
    localStorage.clear()
    toast.success("Log out successfully")
  }


  //@ts-ignore
  const totalItems = cartItems.reduce((total, item) => total + item.quantity, 0);



  return (
    <AppBar position="static" style={{ height: "0px", paddingTop: "0px" }}>
      <Container maxWidth="md">
        <ToastContainer autoClose={2000} />

        <Toolbar disableGutters>
          {/* Logo Section - Display on all screen sizes */}
          <Link href="/" sx={{ display: 'flex', alignItems: 'center', textDecoration: 'none', mr: 2 }}>
            <Box
              component="img" // Use Box component with img tag for sx prop
              src="/static/logo.png"
              alt="HatBazaar Logo"
              sx={{
                display: 'block',
                height: { xs: 30, sm: 40 }, // Smaller height on xs, default on sm+
                width: 'auto' // Maintain aspect ratio
              }}
            />
          </Link>

          {/* Mobile Menu */}
          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{
                display: { xs: 'block', md: 'none' },
              }}
            >
              <MenuItem onClick={handleCloseNavMenu} >
                <Link style={{ textDecoration: "none" }}
                  target="_blank" href="/aboutus">About Us
                </Link>
              </MenuItem>
              <MenuItem onClick={handleCloseNavMenu} >
                <Typography textAlign="center">
                  <Link style={{ textDecoration: "none" }}
                    target="_blank" href="https://www.facebook.com/hatbazaar">Contact Us
                  </Link>
                </Typography>
              </MenuItem>
              <MenuItem onClick={handleCloseNavMenu} >
                {!isLoggedIn ? // Use isLoggedIn variable
                  <Button href="/login"   >
                    login
                  </Button> :

                  <Button style={{ marginLeft: "-5px" }} onClick={handleLogout}>Log out</Button>
                }
              </MenuItem>
            </Menu>
          </Box>

          {/* Desktop Navigation Placeholder (Add Nav Links here if needed) */}
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {/* Example Desktop Links:
            <Button href="/aboutus" sx={{ my: 2, color: 'white', display: 'block' }}>About Us</Button>
            <Button href="https://www.facebook.com/hatbazaar" target="_blank" sx={{ my: 2, color: 'white', display: 'block' }}>Contact Us</Button>
            */}
          </Box>

          {/* Right Aligned Actions */}
          {/* Removed redundant Typography element */}
          {/* <Typography
            variant="h5"
            noWrap
            component="a"
            href=""
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
          > </Typography> */}

          <Box sx={{ flexGrow: 0, display: 'flex', alignItems: 'center' }}> {/* Use flexbox for alignment */}
            {/* Desktop Explore Button */}
            <Box sx={{ display: { xs: 'none', md: 'inline-flex' } }}> {/* Use inline-flex */}
              <Tooltip title="See more food items">
                <span> {/* Wrap Button in span */}
                  <Button href="/" startIcon={<LocalDiningIcon />} sx={{ color: 'inherit' }}>Explore</Button>
                </span>
              </Tooltip>
            </Box>
            {/* Cart Button - Show only if logged in */}
            {isLoggedIn && (
              <Tooltip title="See your cart items">
                <span> {/* Wrap IconButton in span */}
                  <IconButton href="/cart" color="inherit" sx={{ ml: 1 }}>
                    <Badge badgeContent={totalItems} color="error">
                      <AddShoppingCartIcon />
                    </Badge>
                  </IconButton>
                </span>
              </Tooltip>
            )}
            {/* Login/Profile Buttons */}
            {/* Login/Profile Buttons */}
            {!isLoggedIn ? ( // Use isLoggedIn variable
              <Button variant="outlined" href="/login" sx={{ ml: 1.5, color: 'inherit', borderColor: 'rgba(255, 255, 255, 0.5)' }}> {/* Adjust margin and style */}
                Login
              </Button>
            ) : ( // Use isLoggedIn variable
              <Tooltip title="See Profile">
                <Button variant="outlined" href="/profile" sx={{ ml: 1.5, color: 'inherit', borderColor: 'rgba(255, 255, 255, 0.5)' }}> {/* Adjust margin and style */}
                  Profile
                </Button>
              </Tooltip>
            )}
          </Box>

        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default Navbar;
